import { IconProps } from "./types";

export const LogoutIcon = (props: IconProps) => (
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
  <path d="M1 1.5V19.5M6 10.5H17M17 10.5L14 7.5M17 10.5L14 13.5" stroke="black" stroke-width="2" stroke-linecap="round"/>
</svg>
);
